import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-themify-icon',
	templateUrl:'./ThemifyIconPluginCompPage.html',
	styles: [],
	styleUrls:['./ThemifyIconPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ThemifyIconPluginCompPage
{
	mdContent_1106 = `\`\`\`java
import com.jwebmp.plugins.themify.icons.ThemifyIcon;
\`\`\``;
	mdContent_1107 = `\`\`\`java
ThemifyIcons icon
\`\`\``;
	mdContent_1108 = `\`\`\`java

\`\`\``;
	mdContent_1109 = `\`\`\`java
var icon = new ThemifyIcon&lt;&gt;(ThemifyIcons.home);
\`\`\``;
	mdContent_1110 = `\`\`\`java
var icon = new ThemifyIcon&lt;&gt;(ThemifyIcons.github);
\`\`\``;
}
